import { useNotifyActionStatus } from 'server';

export interface IHandleNotifyActionStatusData {
    notifyActionStatus: ReturnType<typeof useNotifyActionStatus>;
}

export const handleNotifyActionStatus = (push: any, { notifyActionStatus }: IHandleNotifyActionStatusData) => {
    const { action, actionId } = push.data;

    if (!actionId || !action?.actionShowAdvancedDialogInfo) {
        // only needed if actionShowAdvancedDialogInfo
        return null;
    }

    return notifyActionStatus({
        actionId,
        messageDisplayed: true
    });
};
